import { environment } from 'environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { RuntimeConfigService } from 'app/core/config/runtime-config.service';

export function initializer(keycloak: KeycloakService, configService: RuntimeConfigService): () => Promise<boolean> {
        return async (): Promise<boolean> => {
                await configService.loadConfig(); // Ensure config is loaded first
                const authConfig = configService.authConfig;
                return keycloak.init({
                        config: {
                                url: authConfig.url,
                                realm: authConfig.realm,
                                clientId: authConfig.clientId
                        },
                        loadUserProfileAtStartUp: true,
                        enableBearerInterceptor: true,
                        shouldAddToken: (req) => {
                                const apiUrl = configService.apiUrl;
                                const apiUrlNoSlash = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
                                return req.url.startsWith(apiUrlNoSlash);
                        },
                        initOptions: {
                                checkLoginIframe: false,
                                enableLogging: true,
                                onLoad: 'login-required',
                                // silentCheckSsoRedirectUri:
                                //      window.location.origin + '/assets/silent-check-sso.html',
                        },
                });
        };
}
